import React from "react";
import logo from "../../assets/login.png"; 

const SessionLoading = () => {
 return (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "linear-gradient(180deg, #d32f2f 0%, #b71c1c 100%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      zIndex: 99999,
    }}
  >
    {/* Background Glow */}
    <div
      style={{
        position: "absolute",
        width: "300px",
        height: "300px",
        background: "rgba(255,255,255,0.12)",
        borderRadius: "50%",
        top: "-80px",
        left: "-80px",
        filter: "blur(80px)",
      }}
    />

    <div
      style={{
        position: "absolute",
        width: "260px",
        height: "260px",
        background: "rgba(255,255,255,0.08)",
        borderRadius: "50%",
        bottom: "-80px",
        right: "-60px",
        filter: "blur(70px)",
      }}
    />

    {/* Glass Card */}
    <div
      style={{
        position: "relative",
        textAlign: "center",
        color: "#fff",
        width: "90%",
        maxWidth: "340px",
        padding: "35px 28px",
        borderRadius: "24px",
        background: "rgba(255,255,255,0.12)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        border: "1px solid rgba(255,255,255,0.20)",
        boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
        overflow: "hidden",
      }}
    >
      {/* Glass Shine */}
      <div
        style={{
          position: "absolute",
          top: "-70px",
          left: "-70px",
          width: "180px",
          height: "180px",
          background: "rgba(255,255,255,0.18)",
          borderRadius: "50%",
          filter: "blur(35px)",
        }}
      />

      <img
        src={logo}
        alt="iAttendance"
        style={{
          width: "90px",
          height: "90px",
          objectFit: "contain",
          marginBottom: "22px",
          position: "relative",
          zIndex: 2,
        }}
      />

      <h2
        style={{
          margin: 0,
          fontSize: "30px",
          fontWeight: "700",
          letterSpacing: "1px",
          position: "relative",
          zIndex: 2,
        }}
      >
        iAttendance
      </h2>

      <p
        style={{
          marginTop: "10px",
          fontSize: "15px",
          color: "rgba(255,255,255,0.9)",
          position: "relative",
          zIndex: 2,
        }}
      >
        Restoring your session...
      </p>

      {/* Spinner */}
      <div
        style={{
          width: "54px",
          height: "54px",
          border: "5px solid rgba(255,255,255,0.18)",
          borderTop: "5px solid #ffffff",
          borderRadius: "50%",
          margin: "28px auto 0",
          animation: "spin 0.8s linear infinite",
          position: "relative",
          zIndex: 2,
        }}
      />

      <p
        style={{
          marginTop: "18px",
          fontSize: "13px",
          color: "rgba(255,255,255,0.85)",
          position: "relative",
          zIndex: 2,
        }}
      >
        Please wait while we securely restore your session...
      </p>
    </div>

    <style>
      {`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}
    </style>
  </div>
);
};

export default SessionLoading;